import { Button, DialogContent, DialogTitle } from "@mui/material";
import { useState } from "react";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import EmailOwnershipNotice from "./EmailOwnershipNotice";

interface Props {
  onConfirm: () => void;
  onClose: () => void;
}

const EmailInUseConfirmationDialog = ({ onConfirm, onClose }: Props) => {
  const [confirmed, setConfirmed] = useState(false);

  return (
    <SmallDialog open onClose={onClose}>
      <DialogTitle>Confirm email address</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <EmailOwnershipNotice
          text="This address already belongs to another Entrilia user account. Check that it is the right person before you save."
          confirmLabel="I understand, and want to save this email anyway."
          confirmed={confirmed}
          onConfirmedChange={setConfirmed}
        />
      </DialogContent>
      <DialogButtons onCancel={onClose}>
        <Button variant="contained" disabled={!confirmed} onClick={onConfirm}>
          Save
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default EmailInUseConfirmationDialog;
